import { AppNS } from 'app';

// const SPECIAL_NAMES = ['Lorem ipsum'];
export const SPECIAL_NAMES = [
  'Special Inspection Concrete',
  'Special Inspection Ongoing',
  'Special Inspection SFRM',
  'Special Inspection Steel',
  'SI Concrete',
  'SI Masonry',
  'SI Soils',
  'SI Deep Driven Foundations',
  'SI Cast in Place Deep foundations',
  'SI Fabricated Items',
  'SI Wind',
  'SI Seismic',
  'SI EIFS',
  'SI Underpinning',
  'SI Wood',
  'SI Sheeting and Shoring',
  'SI Earth Retention system',
  'SI Helical Piers',
  'SI Mastic and Intumescent Fire - Resistance Coatings',
  'SI Tower Cranes',
  'SI Testing for seismic resistance',
  'SI Fire - resistant penetrations & Joints',
  'SI Smoke Control',
  'SI Sprayed Fire-Resistant Materials',
  'SI Steel',
  'SI Fire-resistant penetrations & Joints',
  'SI Mastic and Intumescent Fire-Resistance Coatings'
];

const filterSpecialInspections = (
  inspections: Array<AppNS.Inspection> | null
) => {
  if (!inspections) {
    return null;
  }

  return inspections.filter((inspection: AppNS.Inspection) =>
    SPECIAL_NAMES.includes(inspection.id)
  );
};

const filterRegularInspections = (
  inspections: Array<AppNS.Inspection> | null
) => {
  if (!inspections) {
    return null;
  }

  return inspections.filter(
    (inspection: AppNS.Inspection) => !SPECIAL_NAMES.includes(inspection.id)
  );
};

export const filterOutSpecialInspectionsAndZoning = (
  inspections: Array<AppNS.Inspection> | null
) => {
  if (!inspections) {
    return [];
  }

  return inspections.filter(
    (inspection: AppNS.Inspection) => !SPECIAL_NAMES.includes(inspection.id) && inspection.id !== 'Zoning'
  );
};

export const parsePermitsData = (
  data: Array<AppNS.Permit>,
  isSpecial: boolean
): Array<AppNS.Permit> => {
  return data.map((permit: AppNS.Permit) => {
    return {
      ...permit,
      inspections: isSpecial
        ? filterSpecialInspections(permit.inspections)
        : filterRegularInspections(permit.inspections),
    };
  });
};
